import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from '../../axios';

const STATUS_LABELS = {
  active: '有効',
  stopped: '停止',
  reached: '上限到達',
  unset: '未設定',
};

const PrPointManagement = ({ balance, events, purchaseUrl, onDataChange }) => {
  const [editingLimits, setEditingLimits] = useState({});
  const [processing, setProcessing] = useState({});

  const handleLimitChange = (eventId, value) => {
    setEditingLimits(function (prev) {
      var next = Object.assign({}, prev);
      next[eventId] = value;
      return next;
    });
  };

  const getLimitValue = (ev) => {
    if (editingLimits[ev.event_id] !== undefined) return editingLimits[ev.event_id];
    return ev.limit !== null ? String(ev.limit) : '';
  };

  const handleUpdateLimit = async (ev) => {
    var key = 'update_' + ev.event_id;
    setProcessing(function (prev) { var n = Object.assign({}, prev); n[key] = true; return n; });
    try {
      var rawValue = getLimitValue(ev);
      var limitValue = rawValue === '' ? null : parseInt(rawValue, 10);
      await axios.post('/api/events/' + ev.event_id + '/pr_limitations/update', {
        event_id: ev.event_id,
        limit: limitValue,
      });
      if (onDataChange) onDataChange();
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || '設定の更新に失敗しました';
      alert(msg);
    }
    setProcessing(function (prev) { var n = Object.assign({}, prev); n[key] = false; return n; });
  };

  const handleToggle = async (ev) => {
    var key = 'toggle_' + ev.event_id;
    setProcessing(function (prev) { var n = Object.assign({}, prev); n[key] = true; return n; });
    try {
      if (ev.status === 'active' || ev.status === 'reached') {
        await axios.post('/api/events/' + ev.event_id + '/pr_limitations/deactivate', {
          event_id: ev.event_id,
        });
      } else {
        var rawValue = getLimitValue(ev);
        var limitValue = rawValue === '' ? null : parseInt(rawValue, 10);
        await axios.post('/api/events/' + ev.event_id + '/pr_limitations/update', {
          event_id: ev.event_id,
          limit: limitValue,
        });
      }
      if (onDataChange) onDataChange();
    } catch (e) {
      var msg = (e.response && e.response.data && e.response.data.error) || '設定の更新に失敗しました';
      alert(msg);
    }
    setProcessing(function (prev) { var n = Object.assign({}, prev); n[key] = false; return n; });
  };

  return (
    <div className="o-dashboard__section">
      <h3 className="o-dashboard__section-title">PRポイント管理</h3>
      <div className="o-pr-point">
        <div className="o-pr-point__header">
          <div className="o-pr-point__stat">
            残高: <strong>{Number(balance).toLocaleString()}</strong> pt
          </div>
          {purchaseUrl && (
            <a href={purchaseUrl} className="a-button a-button--primary">
              PRチケット購入
            </a>
          )}
        </div>
        {events.length > 0 && (
          <table className="o-data-table">
            <thead>
              <tr>
                <th>イベント名</th>
                <th>上限</th>
                <th>消費済</th>
                <th>状態</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {events.map(function (ev) {
                var isActive = ev.status === 'active' || ev.status === 'reached';
                var isStopped = ev.status === 'stopped';
                var updateKey = 'update_' + ev.event_id;
                var toggleKey = 'toggle_' + ev.event_id;
                return (
                  <tr key={ev.event_id}>
                    <td>{ev.event_name}</td>
                    <td>
                      <input
                        type="number"
                        value={getLimitValue(ev)}
                        placeholder="無制限"
                        min={ev.consumed + 1}
                        disabled={!isActive && !isStopped}
                        onChange={function (e) { handleLimitChange(ev.event_id, e.target.value); }}
                        style={{ width: '80px', padding: '4px 6px', fontSize: '13px' }}
                      />
                      <span style={{ fontSize: '12px', color: '#888', marginLeft: '4px' }}>pt</span>
                    </td>
                    <td>{Number(ev.consumed).toLocaleString()} pt</td>
                    <td>
                      <span className={'o-pr-point__status o-pr-point__status--' + ev.status}>
                        {STATUS_LABELS[ev.status] || ev.status}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {(isActive || isStopped) && (
                          <button
                            type="button"
                            onClick={function () { handleUpdateLimit(ev); }}
                            disabled={!!processing[updateKey]}
                            style={{ fontSize: '12px', padding: '4px 10px', cursor: 'pointer', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '4px' }}
                          >
                            {processing[updateKey] ? '処理中...' : '上限更新'}
                          </button>
                        )}
                        {isActive && (
                          <button
                            type="button"
                            onClick={function () { handleToggle(ev); }}
                            disabled={!!processing[toggleKey]}
                            style={{ fontSize: '12px', padding: '4px 10px', cursor: 'pointer', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '4px' }}
                          >
                            {processing[toggleKey] ? '処理中...' : '停止'}
                          </button>
                        )}
                        {isStopped && (
                          <button
                            type="button"
                            onClick={function () { handleToggle(ev); }}
                            disabled={!!processing[toggleKey]}
                            style={{ fontSize: '12px', padding: '4px 10px', cursor: 'pointer', background: '#22c55e', color: '#fff', border: 'none', borderRadius: '4px' }}
                          >
                            {processing[toggleKey] ? '処理中...' : '再開'}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

PrPointManagement.propTypes = {
  balance: PropTypes.number.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      event_id: PropTypes.number,
      event_name: PropTypes.string,
      limit: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
      consumed: PropTypes.number,
      status: PropTypes.string,
    })
  ).isRequired,
  purchaseUrl: PropTypes.string,
  onDataChange: PropTypes.func,
};

export default PrPointManagement;
